import { ReactNode } from 'react';

import {
  UseWorkflowPermissionOptions,
  UseWorkflowPermissionResult,
  useWorkflowPermission,
} from '../../hooks';

type RenderProps = (props: UseWorkflowPermissionResult) => ReactNode;

type WorkflowPermissionProps = UseWorkflowPermissionOptions & {
  children: RenderProps;
};

export function WorkflowPermission({
  children,
  ...options
}: WorkflowPermissionProps) {
  const props = useWorkflowPermission(options);
  return children(props);
}
